import * as Sentry from '@sentry/vue';

const logger = {
  info (message) {
    Sentry.captureMessage(message);
  },

  error (message) {
    Sentry.captureException(message);
  },
};

const message = function (message) {
  logger.info(message);
};

const exception = function (message) {
  logger.error(message);
};

logger.install = function (Vue) {
  Vue.prototype.$sentry_message = message;
  Vue.prototype.$sentry_exception = exception;
};

export default logger;
